import React, { memo } from 'react';
import cls from './MeasurementsList.module.css';
import { useMeasurementsList } from './useMeasurementsList';
import { MeasurementCard } from '../UI/MeasurementCard/MeasurementCard';

export const MeasurementsList = memo(({}) => {
    const { measurementsIds } = useMeasurementsList();

    return (
        <div className={cls.MeasurementsList}>
            {measurementsIds.map((measurementId) => (
                <MeasurementCard key={measurementId} measurementId={measurementId} />
            ))}
        </div>
    );
});
